import { Button, Dropdown } from '@usitsdasdesign/dds-react';
import Badge from 'atoms/Badge';
import Text from 'atoms/Text';
import Drawer from 'molecules/Drawer';
import DropdownV2 from 'molecules/Dropdown';
import Empty from 'molecules/Empty';
import moment from 'moment';

function SavedFilters({ show = false, data = [], onClose, onMakeDefaultFilter, onFilterDelete, onSavedFilterSelect }) {

    if (!show) return null;

    const items = [
        {
            label: "Make as Default",
            onSelectedItem: (item) => onMakeDefaultFilter(item)
        },
        {
            label: "Delete",
            onSelectedItem: (item) => onFilterDelete(item)
        },
    ];

    const getItemMenu = (item) => {
        if (item.isDefault) return [items[1]];
        return items;
    }

    return (
        <Drawer
            show={true}
            title="Saved filters"
            onClose={onClose}
        >
            <div className='flex flex-col gap-2'>
                {
                    data.length ? (
                        data.map((item) => {
                            return (
                                <div key={item.id} className={`border border-gray-400 p-2`}>
                                    <div className='flex items-center gap-2 justify-between'>
                                        <Text variant='bodySemibold'>{item.name} {item?.isDefault && <span className='text-xs text-gray-1000 font-normal'>(Default)</span>}</Text>
                                        <div className='flex items-center gap-2'>
                                            <Button
                                                label={item?.isSelected ? 'Selected' : 'Select'}
                                                kind='silent'
                                                isDisabled={item?.isSelected}
                                                onClick={() => onSavedFilterSelect(item)}
                                            />
                                             <DropdownV2
                                                className="iconDropdown"
                                                zIndex='z-[1001]'
                                                color="dark"
                                                dropdownItems={getItemMenu(item)}
                                                icon="context_menu__l__filled"
                                                kind="silent"
                                                onChange={(i) => {
                                                    i.onSelectedItem(item)
                                                }}
                                                size="m"
                                            />
                                        </div>
                                    </div>
                                    {
                                        item.filters.length > 0 && (
                                            <div className='flex gap-1 flex-wrap mt-1'>
                                                {
                                                    item.filters.map((filter, i) => {
                                                        const isDate = new Date(filter.values)?.toString() !== 'Invalid Date'
                                                        const isFilterObj = Array.isArray(filter.values)
                                                        return (
                                                            <div key={i} className='text-xs bg-white border border-gray-200 py-0.5 px-2'>
                                                                {filter.title} : {isFilterObj ? filter?.values?.map(it => it.label).join(', ') : (
                                                                    isDate ?
                                                                        moment(filter.values).format("DD/MM/YYYY") :
                                                                        Object(filter.values).toString()
                                                                )}
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        )
                                    }
                                </div>
                            )
                        })
                    ) : (
                        <Empty
                            message='No filters saved'
                            description='Save filters to select'
                            isShowCta={false}
                            height='h-[calc(100vh-11rem)]'
                        />
                    )

                }
            </div>
        </Drawer>
    )
}

export default SavedFilters